var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhonelink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 7.99967H29.8333V5.33301H5.83333C4.36667 5.33301 3.16667 6.53301 3.16667 7.99967V22.6663H0.5V26.6663H19.1667V22.6663H5.83333V7.99967ZM31.1667 10.6663H23.1667C22.4333 10.6663 21.8333 11.2663 21.8333 11.9997V25.333C21.8333 26.0663 22.4333 26.6663 23.1667 26.6663H31.1667C31.9 26.6663 32.5 26.0663 32.5 25.333V11.9997C32.5 11.2663 31.9 10.6663 31.1667 10.6663ZM24.5 22.6663H29.8333V13.333H24.5V22.6663Z",
    fill: "#FEB53E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonelink);
export default __webpack_public_path__ + "static/media/phonelink.a8423a41ea26644867bdde299a369354.svg";
export { ForwardRef as ReactComponent };